module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/results02-b5a9a650d4460b7a5a77c8bce07d7348.png";